<template>
    <div :class="color" class="semibold" @click="$emit('onClickAddPref')">
        <i v-if="iconPosition === 'left'" :class="icon" class="icon-left"></i>
        <span>{{ $l10n.__('Ajouter une préférence à mettre à jour') }}</span>
        <i v-if="iconPosition === 'right'" :class="icon" class="icon-right"></i>
    </div>
</template>

<script>
export default {
    name: "TextIcon",
    props: {
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'black'
        },
        iconPosition: {
            type: String,
            default: "left"
        }
    }
}
</script>

<style scoped lang="scss">
div {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.icon-left {
    margin-right: 6px;
}

.icon-right {
    margin-left: 6px;
}
</style>
